/* Movimiento: todo lo que no se puede resolver solo con CSS.

   Lo primero que hace este archivo es apagar la red de seguridad que puso
   la cabecera. Si este archivo no llega, o revienta antes de esa linea,
   la red se dispara sola a los 2,5 s, quita la clase .mov y el sitio se
   ve entero sin animacion. Nunca mas una pagina en negro esperando un JS.
*/
(function () {
  "use strict";

  var raiz = document.documentElement;
  var quieto = !raiz.classList.contains("mov");
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function rendirse() {
    raiz.classList.remove("mov");
    $$(".rv,[data-ola]").forEach(function (n) { n.classList.add("in"); });
    $$("img.cargando").forEach(function (n) { n.classList.remove("cargando"); n.classList.add("cargada"); });
  }

  try {

    /* ── Revelar al bajar ────────────────────────────────────────
       Se observa una sola vez y se deja de observar: un observador vivo
       por cada bloque de una pagina de 400 productos es trabajo regalado.

       v7.0: las grillas ([data-ola]) se revelan apenas asoma su primer
       pixel. Antes pedian que se viera el 5 % de la grilla, y en una
       coleccion de 250 modelos ese 5 % son mil pixeles: la pagina se
       quedaba en blanco hasta que la persona bajaba. */
    function mirar(sel, umbral, margen) {
      var nodos = $$(sel).filter(function (n) { return !n.classList.contains("in"); });
      if (quieto || !("IntersectionObserver" in window)) {
        nodos.forEach(function (n) { n.classList.add("in"); });
        return;
      }
      var io = new IntersectionObserver(function (filas) {
        filas.forEach(function (f) {
          if (!f.isIntersecting) { return; }
          f.target.classList.add("in");
          io.unobserve(f.target);
        });
      }, { rootMargin: margen, threshold: umbral });
      nodos.forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0 && umbral === 0) { n.classList.add("in"); return; }
        io.observe(n);
      });
    }

    $$(".sec-head").forEach(function (h, i) { h.style.setProperty("--i", i % 3); });
    $$(".prods, .cats, .quick, .tiles, .steps, .trust, .revs, .accs, .rail, .jugs, .par-opts")
      .forEach(function (g) { g.setAttribute("data-ola", ""); });

    mirar(".rv", 0.05, "0px 0px -7% 0px");
    mirar("[data-ola]", 0, "0px 0px 0px 0px");

    /* Desde aqui el sitio ya sabe revelarse solo: se quita la red. */
    if (window.__tlrRed) { clearTimeout(window.__tlrRed); window.__tlrRed = null; }

    /* ── Las fotos entran enfocandose ─────────────────────────────
       Solo las que todavia no cargaron. Las que ya estan en pantalla no
       se tocan: hacerlas parpadear seria peor que no hacer nada. */
    if (!quieto) {
      $$("img").forEach(function (im) {
        if (im.complete && im.naturalWidth) { return; }
        im.classList.add("cargando");
        var listo = function () { im.classList.remove("cargando"); im.classList.add("cargada"); };
        im.addEventListener("load", listo, { once: true });
        im.addEventListener("error", listo, { once: true });
      });
      /* Si alguna nunca dispara load, a los 4 s se muestra igual. */
      setTimeout(function () {
        $$("img.cargando").forEach(function (im) {
          im.classList.remove("cargando"); im.classList.add("cargada");
        });
      }, 4000);
    }

    /* ── La capsula se esconde al bajar ────────────────────────────
       Con margen de 6 px para que un temblor del dedo no la haga
       parpadear, y nunca en los primeros 140 px. */
    (function () {
      var nav = document.getElementById("nav");
      if (!nav || quieto) { return; }
      var antes = window.scrollY, pendiente = false;
      function revisar() {
        var y = window.scrollY, d = y - antes;
        if (Math.abs(d) > 6) {
          nav.classList.toggle("is-guardada", d > 0 && y > 140);
          antes = y;
        }
        pendiente = false;
      }
      addEventListener("scroll", function () {
        if (pendiente) { return; }
        pendiente = true;
        requestAnimationFrame(revisar);
      }, { passive: true });
    })();

    /* ── El numero que cuenta ─────────────────────────────────────
       900 ms. Mas largo y la persona ya leyo el numero y esta esperando
       a que el sitio termine de presumir. */
    (function () {
      var marcas = $$("[data-cuenta]");
      if (!marcas.length) { return; }
      marcas.forEach(function (el) {
        var fin = parseInt(el.getAttribute("data-cuenta"), 10);
        if (!fin || quieto) { if (fin) { el.textContent = fin; } return; }
        var visto = false;
        var io = new IntersectionObserver(function (f) {
          if (!f[0].isIntersecting || visto) { return; }
          visto = true; io.disconnect();
          var t0 = performance.now();
          (function paso(t) {
            var k = Math.min(1, (t - t0) / 900);
            el.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3)));
            if (k < 1) { requestAnimationFrame(paso); }
          })(t0);
        }, { threshold: 0.6 });
        io.observe(el);
      });
    })();

    /* ── Borde dorado al tocar ────────────────────────────────────
       En telefono no hay :hover. Sin esto, el borde dorado —que es la
       señal de «esta es la que estas mirando»— no existiria en telefono. */
    document.addEventListener("pointerdown", function (e) {
      var c = e.target.closest(".card");
      $$(".card.is-tocada").forEach(function (n) { if (n !== c) { n.classList.remove("is-tocada"); } });
      if (c) { c.classList.add("is-tocada"); }
    }, { passive: true });

    /* ── Zoom de la camisa en la ficha ─────────────────────────────
       El origen del transform sigue al cursor, asi que la foto se agranda
       hacia donde apunta el dedo y se puede recorrer el escudo o la
       costura sin abrir otra ventana.
       Con mouse: entra y sale con el cursor.
       Con dedo: se toca para acercar, se arrastra para mover, se toca
       otra vez para alejar. */
    (function () {
      var caja = document.querySelector(".pdp-media .ph");
      var foto = caja && caja.querySelector("img");
      if (!caja || !foto) { return; }

      var pista = document.createElement("span");
      pista.className = "zoom-pista";
      pista.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5M11 8v6M8 11h6"/></svg>Acercar';
      caja.appendChild(pista);

      function seguir(ev) {
        var r = caja.getBoundingClientRect();
        var x = ((ev.clientX - r.left) / r.width) * 100;
        var y = ((ev.clientY - r.top) / r.height) * 100;
        caja.style.setProperty("--zx", Math.max(0, Math.min(100, x)) + "%");
        caja.style.setProperty("--zy", Math.max(0, Math.min(100, y)) + "%");
      }

      var fino = matchMedia("(hover:hover) and (pointer:fine)").matches;

      if (fino) {
        caja.addEventListener("pointerenter", function () { caja.classList.add("es-zoom"); });
        caja.addEventListener("pointerleave", function () {
          caja.classList.remove("es-zoom");
          caja.style.removeProperty("--zx");
          caja.style.removeProperty("--zy");
        });
        caja.addEventListener("pointermove", seguir);
      } else {
        caja.addEventListener("click", function (ev) {
          if (ev.target.closest("[data-wish]")) { return; }
          seguir(ev);
          caja.classList.toggle("es-zoom");
        });
        caja.addEventListener("touchmove", function (ev) {
          if (!caja.classList.contains("es-zoom")) { return; }
          ev.preventDefault();
          seguir(ev.touches[0]);
        }, { passive: false });
      }
    })();

    /* ── La camisa del hero flota con el cursor ──────────────────────
       Apenas unos pixeles. Lo suficiente para que la camisa se sienta un
       objeto delante del fondo y no una calcomania pegada encima.
       Solo con mouse: en telefono no hay cursor que seguir y el
       acelerometro seria mareo, no diseño. */
    (function () {
      var hero = document.querySelector("[data-pasarela-raiz]") || document.querySelector(".pas");
      if (!hero || quieto || !matchMedia("(hover:hover) and (pointer:fine)").matches) { return; }
      var pista = hero.querySelector("[data-psl-pista]") || hero.querySelector(".pas-foto");
      if (!pista) { return; }
      pista.style.transition = "transform .5s cubic-bezier(.23,1,.32,1)";
      var pendiente = false, mx = 0, my = 0;
      hero.addEventListener("pointermove", function (ev) {
        var r = hero.getBoundingClientRect();
        mx = ((ev.clientX - r.left) / r.width - 0.5) * 16;
        my = ((ev.clientY - r.top) / r.height - 0.5) * 10;
        if (pendiente) { return; }
        pendiente = true;
        requestAnimationFrame(function () {
          pista.style.transform = "translate3d(" + (-mx).toFixed(1) + "px," + (-my).toFixed(1) + "px,0)";
          pendiente = false;
        });
      });
      hero.addEventListener("pointerleave", function () { pista.style.transform = ""; });
    })();

    /* Contenido que llega despues (favoritos, carga completa de
       colecciones) tambien se revela. */
    document.addEventListener("tlr:pintado", function () {
      mirar(".rv", 0.05, "0px 0px -7% 0px");
      mirar("[data-ola]", 0, "0px 0px 0px 0px");
    });

  } catch (e) {
    /* Si algo de aqui arriba fallo, se muestra todo y se sigue. Un sitio
       sin animacion es un problema chico; un sitio en negro no lo es. */
    rendirse();
    if (window.console && console.warn) { console.warn("TLR movimiento:", e); }
  }
})();